const emptyFunc = () => null;

export default emptyFunc;
